// src/directives/blur-on-click.js
export default {
  inserted(el) {
    el.addEventListener('click', () => {
      setTimeout(() => {
        const btn = el.tagName === 'BUTTON'
          ? el
          : el.querySelector('button')
        if (btn && typeof btn.blur === 'function') {
          btn.blur()
        }
      }, 0)
    })
  },
}
